import React from 'react';
import _ from 'lodash';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {Header, Segment, Button, Grid, Pagination} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import {convertDateForDisplay} from 'common/utils';

const emptyStr = '';
const PAGE_SIZE = 25;

export class Prescore extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      prescoreJobData: [],
      activePage: 1,
      pageSize: PAGE_SIZE,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  getPrescoreJobList() {
    return REST.prescore
      .getJobMetadata()
      .then(REST.handler.handleResponse)
      .then((res) => {
        this.setState({
          prescoreJobData: [...res],
          error: false,
        });
      })
      .catch((err) => {
        this.setState({
          error: true,
        });
      });
  }

  scoreApplications = (fundingOpportunityId) => {
    return REST.prescore
      .scoreApplications(fundingOpportunityId)
      .then(REST.handler.handleResponse)
      .catch((err) => {
        this.setState({error: true});
      });
  };

  handleChange = (e) => {
    e.preventDefault();
    const {name, value} = e.target;
    this.setState({[name]: value});
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.scoreApplications(this.state.fundingOpportunityId).then((res) => {
      this.refreshData();
    });
  };

  handleSubmitModal = () => {
    this.setState({
      openModal: true,
      fundingOpportunityId: emptyStr,
    });
  };

  renderPrescoreReRunModal() {
    return (
      <FemaGoModal
        title={'Start prescore'}
        open={this.state.openModal}
        confirmAction={(e) => {
          this.handleSubmit(e);
        }}
        cancelAction={() => {
          this.setState({
            openModal: false,
          });
        }}
        size="tiny"
      >
        <FemaGoTable type="entry" summary="start_prescore">
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Funding opportunity id</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Row>
            <FemaGoTable.InputCell
              key={`{fundingOpportunityId}`}
              title="Funding opportunity id"
              id="fundingOpportunityId"
              name="fundingOpportunityId"
              value={this.state.fundingOpportunityId}
              handleChange={this.handleChange}
              handleBlur={this.handleChange}
              maxLength={501}
            />
          </FemaGoTable.Row>
        </FemaGoTable>
      </FemaGoModal>
    );
  }

  refreshData() {
    this.setState({
      error: false,
      openModal: false,
      fundingOpportunityId: emptyStr,
    });
    this.getPrescoreJobList();
  }

  renderPrescore() {
    let {prescoreJobData} = this.state;

    const {activePage, pageSize} = this.state;

    const entities = prescoreJobData;
    const entitiesToRender = _.slice(
      entities,
      (activePage - 1) * pageSize,
      activePage * pageSize
    );

    let rows = _.map(entitiesToRender, (data, index) => {
      const reRun = (
        <a
          className="rerun"
          onClick={() => {
            this.setState({
              fundingOpportunityId: data.fundingOpportunityId,
              openModal: true,
            });
          }}
          title={`Re-run ${data.fundingOpportunityId}`}
          href="#"
        >
          Re-run
        </a>
      );

      return (
        <FemaGoTable.Row key={index}>
          <FemaGoTable.TextCell>{data.id}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>{data.fundingOpportunityId}</FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {convertDateForDisplay(data.startDate, true)}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {convertDateForDisplay(data.endDate, true)}
          </FemaGoTable.TextCell>
          <FemaGoTable.TextCell>
            {data.endDate != null ? reRun : 'Running'}
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    });

    return (
      <React.Fragment>
        <Segment padded>
          <Grid
            key={'prescoreGrid'}
            doubling
            stackable
            reversed="mobile"
            padded="vertically"
            data-test="grid"
          >
            <Grid.Column className="visible-overflow">
              <Grid verticalAlign="bottom">
                <Grid.Row>
                  <Grid.Column width={8}>
                    <Header as="h3">{'Prescore applications'}</Header>
                  </Grid.Column>
                  <Grid.Column width={3} textAlign="right" />
                  <Grid.Column width={5} textAlign="right">
                    <Button
                      primary
                      title="Start prescore"
                      id="submitBtn"
                      onClick={this.handleSubmitModal}
                    >
                      Start prescore
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <FemaGoTable type="entry" summary="prescore">
                <FemaGoTable.Header>
                  <FemaGoTable.Row>
                    <FemaGoTable.HeaderCell>Job id</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>
                      Funding opportunity id
                    </FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Start date</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>End date</FemaGoTable.HeaderCell>
                    <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                  </FemaGoTable.Row>
                </FemaGoTable.Header>
                <FemaGoTable.Body>{rows}</FemaGoTable.Body>
              </FemaGoTable>

              {entities && entities.length > PAGE_SIZE ? (
                <div className="pagination-wrapper pagination" data-test="paginate">
                  <Pagination
                    totalPages={Math.ceil(entities.length / PAGE_SIZE)}
                    activePage={activePage}
                    onPageChange={(e, data) =>
                      this.setState({activePage: data.activePage})
                    }
                  />
                </div>
              ) : (
                ''
              )}
            </Grid.Column>
          </Grid>
        </Segment>
      </React.Fragment>
    );
  }

  render() {
    let {error} = this.state;
    return (
      <React.Fragment>
        {!error && this.renderPrescore()}
        {this.state.openModal && this.renderPrescoreReRunModal()}
      </React.Fragment>
    );
  }
}

export default Prescore;
